/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SCTransactionTypeFormatter = (cellContent, row, rowIndex) => {
  const { sc_type } = row;
  return (
    <>
      <div className="d-flex align-items-center">{sc_type ? sc_type : "-"}</div>
      <> </>
    </>
  );
};
